/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/receipt/types";
import Confirm from "../../../common/confirm/Confirm";
import { isNil } from "ramda";
import { deleteRequest as deleteReceipt } from "../../../store/receipt/actions";
import { useDispatch } from "react-redux";
import TableActions from "../../../common/table/TableActions";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";

interface Props {
  receiptData?: Data[];
}

interface RowData {
  id: string;
  Name: string;
  For: string;
  Type: string;
}

const mapDataToTable = (receipt: Data[]): RowData[] => {
  return receipt.map((data) => {
    return {
      id: data.id,
      Name: data.attributes.Name,
      For: data.attributes.For,
      Type: data.attributes.Type,
    };
  });
};

export default function ReceiptTable({ receiptData }: Props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentId, setCurrentId] = useState<string | null>(null);
  const data = mapDataToTable(receiptData);

  const viewAction = (rowData: RowData) => {
    history.push(`/receipt/view/${rowData.id}`);
  };

  const editAction = (rowData: RowData) => {
    history.push(`/receipt/edit/${rowData.id}`);
  };

  const deleteAction = (rowData: RowData) => {
    setCurrentId(rowData.id);
    setShowConfirm(true);
  };

  const deleteConfirmationHandler = () => {
    const callback = (error: string | null) => {
      if (error) {
        console.log(error);
      }
    };
    !isNil(currentId) && dispatch(deleteReceipt(currentId, callback));
    setCurrentId(null);
    setShowConfirm(false);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "Name",
      },
      {
        header: "For",
        accessorKey: "For",
      },
      {
        header: "Type",
        accessorKey: "Type",
      },
    ],
    []
  );

  return (
    <>
      <MaterialReactTable
        columns={columns}
        data={data}
        getRowId={(row) => row.id}
        initialState={{
          showGlobalFilter: true,
          showColumnFilters: false,
          density: "spacious",
        }}
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableRowActions
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 20],
        }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "",
            size: 100,
          },
        }}
        positionActionsColumn="last"
        renderRowActions={({ row }) => (
          <TableActions
            section="Receipt"
            onView={() => viewAction(row.original)}
            onEdit={() => editAction(row.original)}
            onDelete={() => deleteAction(row.original)}
          />
        )}
      />

      <Confirm
        isOpen={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => deleteConfirmationHandler()}
        title="Delete Receipt"
        icon="danger"
        confirmLabel="Delete Receipt"
        contentText={`You are about to delete Receipt`}
      />
    </>
  );
}
